<template>
  <div class="text-fix">
    <!-- Esta es la vista general, donde va el titulo con breadcrum y botones -->
    <div class="col-12 d-flex jusitify-content-between">
      <div class="col-6">
        <TitleBreadCrumb :page="page" />
      </div>
      <div class="col-6 text-right align-self-end m-0 pb-0">
        <ActionButton
          variant="outline-success m-2 pl-4 pr-4"
          type="submit"
          i="fas fa-arrow-circle-left"
        >
          Regresar
        </ActionButton>
        <ActionButton
          variant="success m-2 pl-4 pr-4"
          type="submit"
          i="fas fa-save"
        >
          Guardar
        </ActionButton>
        <button
          class="btn btn-dropdown-actions dropdown-toggle ml-1 mb-1 mt-0 pt-1"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="fas fa-file-alt text-green" />
          <span class=" ml-2  btn-text">Informes</span>
        </button>
        <div class="dropdown-menu pb-0 mt-1">
          <a class="drop-item cursor-pointer">
            <em class="fas fa-file-download text-green p-1 pb-2" />
            <span>Formulario EE-05</span>
          </a>
        </div>
      </div>
    </div>

    <div class="dropdown-divider mt-0 pb-2 ml-3 w-100" />

    <!-- VAMOS POR LAS TABS -->
    <div class="col-12">
      <div class="Sub-menu">
        <div class="shadow-bottom">
          <ul class="tab-list nav nav-pills mb-3" role="tablist">
            <li
              v-for="tab in tabsList"
              :key="tab.id"
              class="nav-item text-center"
              :class="{
                'tabs-five': !hasAppointment,
                'tabs-six': hasAppointment,
              }"
            >
              <a
                :id="`${tab.name}-tab`"
                class="nav-link "
                :class="{ active: isActive(tab.id) }"
                :href="`#${tab.name}`"
                role="tab"
                aria-selected="true"
                :aria-controls="`${tab.name}`"
                data-toggle="tab"
                @click.prevent="setActiveTab(tab.id)"
              >
                {{ tab.caption }}

                <i
                  v-if="isInValidTab(tab)"
                  class="fas fa-exclamation-triangle"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="tab-content mb-4">
      <keep-alive>
        <component :is="activeTab" />
      </keep-alive>
    </div>

    <!--Footer-->

    <div class="w-100 pt-4">
      <div class="footer-divider px-0 m-2 w-100" />
      <div class="container-foot d-flex justify-content-end ">
        <ActionButton type="submit" variant="success" i="fas fa-save">
          Guardar
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralTab from '@/views/student/Registration/GeneralTab';
import ReferralDataTab from '@/views/student/Registration/ReferralDataTab';
import EvaluationServicesTab from '@/views/student/Registration/EvaluationServicesTab';
import AppointmentsTab from '@/views/student/Registration/AppointmentsTab';
import PostRegistrationTab from '@/views/student/Registration/PostRegistrationTab';
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb.vue';
import { ActionButton } from '@/components/common';

export default {
  name: 'RegistrationPage',
  components: {
    GeneralTab,
    ReferralDataTab,
    EvaluationServicesTab,
    AppointmentsTab,
    PostRegistrationTab,
    TitleBreadCrumb,
    ActionButton,
  },
  data() {
    return {
      activeTabId: 0,
      activeTab: 'GeneralTab',
      hasAppointment: true, //TODO  Evaluar cuando la tabs cita no esta

      page: {
        icon: 'fas fa-user-circle',
        title: 'Registro: General',
        routes: ['Estudiante', 'Registro', 'General'],
      },
      tabsList: [
        { id: 0, name: 'generalTab', caption: 'General' },
        {
          id: 1,
          name: 'proceduralGuaranteesTab',
          caption: 'Garantías Procesales',
        },
        { id: 2, name: 'referralDataTab', caption: 'Datos de Referido' },
        {
          id: 3,
          name: 'evaluationServicesTab',
          caption: 'Evaluación/Servicios',
        },
        { id: 4, name: 'appointmentsTab', caption: 'Citas' },
        { id: 5, name: 'postRegistrationTab', caption: 'Post-Registro' },
      ],
    };
  },

  methods: {
    setActiveTab(tabId) {
      this.activeTabId = tabId;
      let tab = this.tabsList.find((tab) => tab.id == this.activeTabId);
      this.activeTab = tab.name;
      let tabCaption = tab ? tab.caption : 'General';
      this.page.title = 'Registro: ' + tabCaption;

      return true;
    },
    isActive(tabId) {
      return this.activeTabId === tabId;
    },
    isInValidTab() {
      // TODO: validate tab
      return false;
    },
  },
};
</script>
<style scoped>
a i.fas.fa-exclamation-triangle {
  color: #ff5b5c;
}
a.active i.fas.fa-exclamation-triangle {
  color: white;
}
.tabs-five {
  width: 20%;
}

.tabs-six {
  width: calc(100% / 6);
}
.text-fix {
  font-weight: 400;
}

.footer-divider {
  border: 1px solid #2db782;
}

.dropdown-menu {
  margin-top: 1rem;
}
.dropleft .dropdown-toggle::before {
  display: none;
}
.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  height: 2.375rem;
  color: #2db782;
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  padding: 5px;
}

.dropdown-toggle::after {
  color: #2db782;
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.btn-text {
  text-align: center;
  font: 500 16px/29px Lato;
  letter-spacing: 0;
  color: #2db782;
  opacity: 1;
}
</style>
